// extracted by mini-css-extract-plugin
export var barsWrap = "DetailedStatBars-module--barsWrap--c0a67";
export var statBarBlock = "DetailedStatBars-module--statBarBlock--f2b6a";
export var subStat = "DetailedStatBars-module--subStat--d151d";